import React, { useState, useContext } from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import FilterListOutlinedIcon from "@material-ui/icons/FilterListOutlined";
import Box from "@material-ui/core/Box";
import { useLocation } from 'react-router-dom'
import MenuItem from "@material-ui/core/MenuItem"
import Menu from "@material-ui/core/Menu"

import AccountCircle from "@material-ui/icons/AccountCircle";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import SwapHorizontalCircleOutlinedIcon from "@material-ui/icons/SwapHorizontalCircleOutlined";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";

import LogoNavBar from "../../assets/logo/Marca_TAS_Chile.png";
import ModalMui from "../core/ModalMui";
import FileUploadMui from "../core/FileUploadMui";
import FileUploadReceivers from "../core/FileUploadReceivers";
import DrawerMui from "../core/DrawerMui";
import FiltersTransactions from "../transactions/FiltersTransanctions";
import FiltersShiftClosures from "../transactions/FiltersShiftClosures";
import AuthContext from "../../context/authentication/authContext";
import ModalContext from "../../context/modal/modalContext";
import TableContext from "../../context/table/tableContext";
import PortalContext from "../../context/portal/portalContext";
import ReceiverContext from "../../context/receiver/ReceiverContext"
import ReceiverCreator from '../receivers/ReceiverCreator'
import useMediaQuery from "../../hooks/useMediaQuery";

import { version } from "../../../package.json";

import logo from '../../assets/logo/Marca_TAS_Chile.png'
const useStyles = makeStyles((theme) => ({
  
  userButton:{
    color:"#474A57",
    background:'transparent',
    margin:'10px',
    border:'0px',
    width:"auto",
    height:"40px",
    fontSize:"14px",
    cursor:'pointer'
  },
  redButton:{
    background:'#DA291D',
    borderRadius:"4px 4px 4px 4px",
    color:"#FFFFFF",
    margin:'10px',
    border:'0px',
    width:"71px",
    height:"40px",
    fontSize:"14px",
    cursor:'pointer'
  
  },
  blueButton:{
    background:'#001070',
    borderRadius:"4px 4px 4px 4px",
    color:'#FFFFFF',
    margin:'10px',
    border:'0px',
    width:"171px",
    height:"40px",
    fontSize:"14px",
    cursor:'not-show',

  },
  root: {
    flexGrow: 1,
  },
  containerLogo: {
    flexGrow: 1,
    display: "flex",
  },
  logo: {
    width: "224px",
    height: "60px",
    backgroundImage: `url(${LogoNavBar})`,
    backgroundRepeat: "no-repeat",
    backgroundColor: 'transparent',
    backgroundSize: "cover",
    backgroundPosition: "center",
    border:'none'
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    color: "#808080",
  },
  button: {
    fontSize: "12px",
    color: "#707070",
  },
  icon: {
    marginRight: "5px",
    color: "#707070",
  },
}));

const Header = (props) => {
  const location = useLocation()
  const authContext = useContext(AuthContext);
  const modalContext = useContext(ModalContext);
  const tableContext = useContext(TableContext);
  const portalContext = useContext(PortalContext);
  const receiverContext = useContext(ReceiverContext)

  const [anchorEl, setAnchorEl] = useState(null); //MENU ADMINISTRACIÓN
  const [anchorEl2, setAnchorEl2] = useState(null); //MENU FACTURAS->VENTA
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);

  const { terminals,setIsBill,isBill } = portalContext;
  const { user, closeSession, hasToChange } = authContext;
  const { modalShow, showModal, closeModal } = modalContext;
  const { transactionTable, shiftClosuresTable, removeFilters } = tableContext;
  const { receivers,setHistory,currentType,setCurrentItem,setShowEditReceiver,error,receiversClearResults } = receiverContext
  const [isHome, setIsHome] = React.useState(false)
  const [isPortalFacturaPage, setIsPortalFacturaPage] = React.useState(false)
  const [isPortalBoletaPage, setIsPortalBoletaPage] = React.useState(false)
  const [isCustomer, setIsCustomer] = React.useState(false)
  const [isProvider, setIsProvider] = React.useState(false)
  const [isTransactions, setIsTransactions] = React.useState(false)
  const [isBillsList, setIsBillsList] = React.useState(false)
  const classes = useStyles();
  let open = Boolean(anchorEl);
  let open2 = Boolean(anchorEl2);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenu2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  const handleOpenDrawer = () => {
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
  };

  const toChangePassword = () => {
    props.history.push(`/app/change-password`);
  };

  const toChangePosPassword = () => {
    props.history.push(`/app/change-pos-password`);
  };

  const toRegenerateUnauthorizedDocuments = () => {
    props.history.push(`/app/regenerate-unauthorized-documents`);
  };

  const askForANewService = () => {
    props.history.push(`/app/ask-for-a-new-service`);
  };

  const receiveNewVoucherToProcess = () => {
    props.history.push(`/app/receive-new-voucher-to-process`);
  };

  const tellAFriend = () => {
    props.history.push(`/app/tell-a-friend`);
  };

  const toPage = (page) => {
    removeFilters();
    setAnchorEl(null)
    setAnchorEl2(null);
    props.history.push(`/app/${page}`);
  };
  const toShowBills = () => {
   toPage(`bills-list`);
  };

  const toNewBill = () => {
    toPage(`new-bill`);
  };

  const logout = () => {
    /* props.history.push("/auth/login"); */
    localStorage.clear();
    closeSession();
    window.location.href = "/auth/login";
  };

  const showCAFModal = () => {
   setAnchorEl(null)
   setAnchorEl2(null)
    setModalTitle("Gestor CAF");
    setModalContent(<FileUploadMui closeModal={closeModal} type="caf" />);
    showModal();
  };

  const showCertificatesModal = () => {
  setAnchorEl(null)
     setAnchorEl2(null)
    setModalTitle("Gestor Certificados (archivo nombre debe ser igual a RUT)");
    setModalContent(
      <FileUploadMui closeModal={closeModal} type="certificados" />
    );
    showModal();
  };
  const showNewItem=()=>{
  //console.log('showNewItem')
    setModalTitle("NUEVO " + (currentType===1?'CLIENTE':'PROVEEDOR'))
    setModalContent(<ReceiverCreator type={currentType}/>)

    showModal();
  }
  function showUpload(){
       setModalTitle("GESTOR DE " + (currentType===1?'CLIENTES':'PROVEEDORES'))
       setModalContent(<FileUploadReceivers closeModal={closeModal} type={currentType} />)
       showModal();
  }
  function ModalError(props){
    return(
      <>
        {props.msg}
        <button onClick={closeModal}>Cerrar</button>
      </>
    )
  }
  function showErrorModal(errorMsg){
         setModalTitle("Ocurrió un error")
         let msg = errorMsg
         if(errorMsg.response.data.msg)msg = errorMsg.response.data.msg
         setModalContent(<ModalError msg={msg}/>)
         showModal(); 
    }
  function showEditReceiver(item, currentType){
 // //console.log(receivers)
      //const dt = receivers.receivers.filter(x=>x.id==currentId)[0]
      ////console.table(item )
      setModalTitle("EDITAR " + (currentType===1?'CLIENTE':'PROVEEDOR'))
      setModalContent(<ReceiverCreator type={currentType} data={item}/>)
      showModal();
  }
  const goToPortalFactura=()=>{
    localStorage.setItem('IsBill','ISBILL')
    setIsBill("ISBILL")
    toPage('portal')
  }
  const goToPortalBoleta=()=>{
    localStorage.setItem('IsBill','ISNOTBILL')
    setIsBill("ISNOTBILL")
    toPage('portal')
  }
  const goToHome=()=>{
    toPage('home')
  }
 const goToCustomers=()=>{
  toPage('customers')
 }
 const goToProviders=()=>{
  toPage('providers')
 }
 const goToTransactions=()=>{
    toPage('transactions')
 }
 function puntoVenta(){
    window.open('https://webaccess.tasproventas.com/login','_blank')
  }
  const isMobile = useMediaQuery("max-width", 600);

  React.useEffect(()=>{
      if(location.pathname !== '/app/new-bill'){
        sessionStorage.removeItem('referenceData')
      }
      const pf= location.pathname === '/app/portal' &&  isBill==="ISBILL"
      const pb= location.pathname === '/app/portal' &&  !pf
      const cu= location.pathname === '/app/customers'
      const pr= location.pathname === '/app/providers'
      const tr= location.pathname === '/app/transactions'
      const bl= location.pathname === '/app/bills-list' || location.pathname === '/app/new-bill'

      setIsHome(!pf&&!pb&&!cu&&!pr&&!tr&&!bl)

     //  //console.log('home',pf,pb,cu,pr,tr,bl)
      setIsPortalFacturaPage(pf)
      setIsPortalBoletaPage(pb)
      setIsCustomer(cu)
      setIsProvider(pr)
      setIsTransactions(tr)
      setIsBillsList(bl)

      open =false
      open2 =false
      setAnchorEl(null);
      setAnchorEl2(null);
      setModalContent()
      setModalTitle()
      closeModal()
  },[location])

  React.useEffect(()=>{
    //  if(error)showErrorModal(error)
  },[error])

  React.useEffect(()=>{
    receiversClearResults()
    setHistory(props.history)
    setShowEditReceiver(showEditReceiver) //TODO move to receivers

    const tpB = localStorage.getItem('IsBill')
    if(tpB && tpB!=''){
        setIsBill(tpB)
    }
  },[])

  function setModalInfo(title,Content){
    setModalTitle()
  }
  return (
    <div className={classes.root}>
        {modalShow &&
      <ModalMui
        modalShow={modalShow}
        showModal={showModal}
        closeModal={closeModal}
        modalTitle={modalTitle}
      >
        {modalContent}
      </ModalMui>
      }

      <AppBar position="fixed" style={{ background: "#fff",display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between' }}>
        {
          isHome &&
        <Toolbar>
            <button className={classes.logo} style={{ margin: !isMobile ? "" : "auto" }}/>
            <button className={classes.userButton} onClick={goToPortalBoleta}>
              Boleta
            </button>
            {
              localStorage.getItem("hasIntegrationsRole") === "true" &&
              <button className={classes.userButton} onClick={goToPortalFactura}>Factura</button>            
            }
            <button className={classes.userButton} onClick={puntoVenta}>
              Punto de venta
            </button>
            <button className={classes.userButton} onClick={handleMenu}>
              Administración
            </button>
        </Toolbar>
        }
        {
         isPortalBoletaPage &&
            <Toolbar>
             <button className={classes.logo} style={{ margin: !isMobile ? "" : "auto" }}/>
             <button className={classes.userButton} onClick={goToPortalBoleta}>
              Portal
             </button>
             <button className={classes.userButton} onClick={goToTransactions}>
              Transacciones
            </button>
            <button className={classes.userButton} onClick={handleMenu}>
              Administración
            </button>
            <button className={classes.userButton} onClick={goToHome} >
              Home
            </button>
           </Toolbar>
        }
        {
          isPortalFacturaPage &&
            <Toolbar>
             <button className={classes.logo} style={{ margin: !isMobile ? "" : "auto" }}/>
             <button className={classes.userButton} onClick={handleMenu2} >
              Venta
             </button>
            <button className={classes.userButton} onClick={handleMenu}>
              Administración
            </button>
            <button className={classes.userButton} onClick={goToHome} >
              Home
            </button>
        </Toolbar>
        }
         {
          isBillsList &&
                <Toolbar>
                 <button className={classes.logo} style={{ margin: !isMobile ? "" : "auto" }}/>
                 <button className={classes.userButton} onClick={handleMenu2} >
                  Venta
                 </button>

                <button className={classes.userButton} onClick={handleMenu}>
                  Administración
                </button>
                 <button className={classes.userButton} onClick={goToPortalFactura}>
                  Portal
                </button>
                <button className={classes.userButton} onClick={goToHome} >
                  Home
                </button>
            </Toolbar>
        }
         {
          isTransactions &&
            <Toolbar>
             <button className={classes.logo} style={{ margin: !isMobile ? "" : "auto" }}/>
            <button className={classes.userButton} onClick={goToPortalBoleta} >
             Portal
           </button>
            <button className={classes.userButton} onClick={handleMenu}>
              Administración
            </button>
            <button className={classes.userButton} onClick={goToHome} >
              Home
            </button>
        </Toolbar>
     }
        {
          (isCustomer||isProvider) &&
            <Toolbar>
                <button className={classes.logo} style={{ margin: !isMobile ? "" : "auto" }}/>
                <button className={classes.userButton} onClick={showNewItem} >
                  Nuevo
                </button>
                <button className={classes.userButton} onClick={showUpload}>
                  Importar
                </button>
                <button className={classes.userButton} onClick={goToPortalFactura} >
                  Portal
                </button>
                <button className={classes.userButton} onClick={goToHome} >
                  Home
                </button>

            </Toolbar>
            }
        <Toolbar>
            <button onClick={logout} className={classes.redButton}>
              Salir
            </button>
            <button className={classes.blueButton} >
              {user}
            </button>
        </Toolbar>
        <Menu
            id="menu-appbar2"
            anchorEl={anchorEl2}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={open2}
            onClose={handleClose2}
              >
             <div style={{ textAlign: "left" , paddingLeft:'15px'}}>
              <Typography style={{ fontSize: "14px" }}>
                VENTA:
              </Typography>
            </div>
            <MenuItem onClick={toShowBills}>CONSULTAR VENTAS</MenuItem>
            <MenuItem onClick={toNewBill}>EMITIR DOCUMENTO</MenuItem>
        </Menu>
        <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={open}
            onClose={handleClose}
          >
            <div style={{ textAlign: "center" }}>
              <Typography style={{ fontSize: "14px" }}>
                Versión{version}
              </Typography>
            </div>
            <MenuItem onClick={toChangePassword}>Cambiar contraseña</MenuItem>
            {
              (user != null ? user.includes("tas_") : false) &&
              <MenuItem onClick={toChangePosPassword}>Blanquear contraseña POS</MenuItem>
            }
            {
              (user != null ? user.includes("tas_") : false) &&
              <MenuItem onClick={toRegenerateUnauthorizedDocuments}>Regenerar DTEs desautorizados</MenuItem>
            }
            <MenuItem onClick={askForANewService}>Solicitar nuevo servicio</MenuItem>
            <MenuItem onClick={receiveNewVoucherToProcess}>Ingresar nuevo cupón</MenuItem>
            <MenuItem onClick={tellAFriend}>Referir nuevo comercio</MenuItem>
            <MenuItem onClick={showCAFModal}>Gestión CAF</MenuItem>
            <MenuItem onClick={showCertificatesModal}>Gestión CD </MenuItem>
            {
              localStorage.getItem("hasIntegrationsRole") === "true" &&
              <MenuItem onClick={goToCustomers}>Clientes</MenuItem>
            }
            {
              localStorage.getItem("hasIntegrationsRole") === "true" &&
              <MenuItem onClick={goToProviders}>Proveedores</MenuItem>
            }
            <MenuItem onClick={logout}>Salir</MenuItem>
        </Menu>
      </AppBar>
      {isMobile && (
        <DrawerMui
          title="Aplicar Filtros"
          open={drawerOpen}
          handleCloseDrawer={handleCloseDrawer}
        >
          {transactionTable ? (
            <FiltersTransactions terminals={terminals} />
          ) : (
            <FiltersShiftClosures terminals={terminals} />
          )}
        </DrawerMui>
      )}
    </div>
  );
};

export default withRouter(Header);
